import { mix, observable } from "@chorda/core";
export const Button = (props) => {
    return mix({
        tag: 'button',
        css: 'button',
        templates: {
            leftIcon: {
                weight: -10
            },
            content: {
                tag: 'span',
                reactions: {
                    text: (v) => ({ text: v })
                }
            },
            rightIcon: {
                weight: 10
            }
        },
        reactions: {
            color: (next, prev) => ({
                classes: {
                    [next]: true,
                    [prev]: false
                }
            }),
            disabled: (v) => ({ dom: { disabled: v } }),
            active: (v) => ({
                classes: {
                    'is-active': v
                }
            })
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        css: props.css,
        classes: {
            'is-static': props.static
        },
        text: (!props.leftIcon && !props.rightIcon) && !props.icon && props.text,
        // templates: {
        //     content: {
        //         text: props.text
        //     }
        // },
        components: {
            leftIcon: props.leftIcon,
            rightIcon: props.rightIcon,
            icon: props.icon,
            content: (!!props.leftIcon || !!props.rightIcon),
        },
        defaults: {
            color: () => observable(props.color),
            active: () => observable(props.active),
            text: () => observable(props.text),
        },
        injections: {
            color: props.color$,
            text: props.text$,
            disabled: props.disabled$,
            active: props.active$,
        },
        events: {
            $dom: {
                click: props.onClick
            }
            //click: props.onClick
        }
    });
};
export const Buttons = (props) => {
    return {
        css: 'buttons',
        classes: {
            'is-centered': props.centered
        },
        items: props.buttons,
        defaultItem: props.defaultButton
    };
};
